import axios from 'axios';
import { authMsg } from '../../utils/auth';
import { getCommonError } from '../../utils';

/*** TYPES ***/
const REPORT_BUILDER_ACTIVITIES_LOADING = 'REPORT_BUILDER_ACTIVITIES_LOADING';
const REPORT_BUILDER_ACTIVITIES_DATA = 'REPORT_BUILDER_ACTIVITIES_DATA';
const REPORT_BUILDER_ORG_ID = 'REPORT_BUILDER_ORG_ID';
const REPORT_BUILDER_ACTIVITY_LOADING = 'REPORT_BUILDER_ACTIVITY_LOADING';
const REPORT_BUILDER_ACTIVITY_DATA = 'REPORT_BUILDER_ACTIVITY_DATA';

/*** REDUCER ***/
const initialState = {
  activitiesLoading: false,
  activities: [],
  selectedOrgId: null,
  activityLoading: false,
  activity: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case REPORT_BUILDER_ACTIVITIES_LOADING:
      return { ...state, activitiesLoading: action.payload };
    case REPORT_BUILDER_ACTIVITIES_DATA:
      return { ...state, activities: action.payload };
    case REPORT_BUILDER_ORG_ID:
      return { ...state, selectedOrgId: action.payload };
    case REPORT_BUILDER_ACTIVITY_LOADING:
      return { ...state, activityLoading: action.payload };
    case REPORT_BUILDER_ACTIVITY_DATA:
      return { ...state, activity: action.payload };
    default:
      return state;
  }
}

/*** ACTIONS ***/

export function getReportBuilderActivities(orgId) {
  return async (dispatch) => {
    try {
      dispatch({ type: REPORT_BUILDER_ORG_ID, payload: orgId });
      dispatch({ type: REPORT_BUILDER_ACTIVITIES_LOADING, payload: true });
      dispatch({ type: REPORT_BUILDER_ACTIVITIES_DATA, payload: [] });
      const response = await axios.get('/report-builder/activities', {
        params: { orgId },
      });
      dispatch({
        type: REPORT_BUILDER_ACTIVITIES_DATA,
        payload: response.data.activities || [],
      });
      dispatch({ type: REPORT_BUILDER_ACTIVITIES_LOADING, payload: false });
    } catch (error) {
      dispatch({ type: REPORT_BUILDER_ACTIVITIES_LOADING, payload: false });
      authMsg('error', getCommonError(error));
    }
  };
}

export function getReportBuilderActivity(activityId) {
  return async (dispatch) => {
    try {
      dispatch({ type: REPORT_BUILDER_ACTIVITY_LOADING, payload: true });
      dispatch({ type: REPORT_BUILDER_ACTIVITY_DATA, payload: null });
      const response = await axios.get('/report-builder/activity', {
        params: { activityId },
      });
      dispatch({
        type: REPORT_BUILDER_ACTIVITY_DATA,
        payload: response.data.activity || null,
      });
      dispatch({ type: REPORT_BUILDER_ACTIVITY_LOADING, payload: false });
    } catch (error) {
      dispatch({ type: REPORT_BUILDER_ACTIVITY_LOADING, payload: false });
      authMsg('error', getCommonError(error));
    }
  };
}
